import { ReactElement } from "react";
import { IonItem, IonDatetime } from "@ionic/react";
import { HourFormatEnum, HourQuestionType } from "../../../../types/Question";

interface AnswerHourProps {
  value?: string;
  question: HourQuestionType;
  onChange: (value: string) => void;
}

const AnswerHour = ({
  question,
  value = "",
  onChange,
}: AnswerHourProps): ReactElement => {
  const {
    detail: { format },
  } = question;

  // Respect the format chosen in Diapason: 12-hour (AM/PM) vs 24-hour. Without this, IonDatetime
  // falls back to the device locale, which was always showing AM/PM regardless of the setting.
  const hourCycle = format === HourFormatEnum["12HOURS"] ? "h12" : "h23";

  return (
    <IonItem>
      <IonDatetime
        presentation="time"
        hourCycle={hourCycle}
        value={value}
        className="res-text-input"
        onIonChange={(e) =>
          onChange(Array.isArray(e.detail.value) ? e.detail.value[0] : e.detail.value!)
        }
      />
    </IonItem>
  );
};

export default AnswerHour;
